import { BusinessUnitIdParser } from '@estee/elc-formatters';

import Config from '~domain/entities/Config/Config';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';

const langFromBuid = () => {
    const { businessUnitId = '' } = diContainer.get(serviceNames.config) as Config;
    const { language } = businessUnitId
        ? new BusinessUnitIdParser(businessUnitId)
        : { language: 'EN' };

    return language;
};

export default () => {
    const regex = new RegExp('(^| )LOCALE=([^;]+)');
    const match = document.cookie.match(regex);

    return match ? match[2].split('_')[0] : langFromBuid();
};
